// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"518ed171","455":"033f35e3","977":"cb818483"}[chunkId] + ".chunk.js";
};